import BannerUtils from './BannerUtils.js';
import BannerRequest from './BannerRequest.js';
import BannerListeners from './BannerListeners.js';
import BannerContext from './BannerContext.js';

export default {
    name: 'bannerastservice',
    dependencies: ['radio', 'sitesettings', 'trackingservice'],
    callable(radio, sitesettings, trackingservice) {
        // initialize context
        const ctx = new BannerContext(
            null,
            radio,
            sitesettings,
            trackingservice
        );
        ctx.initApnTag();
        ctx.initAppNexusData();

        const isAdBlocker = BannerUtils.isAdBlockerActive();

        // initialize listeners
        const bannerList = new BannerListeners(ctx);
        bannerList.initApnListeners();
        bannerList.refreshAfterSearch();
        bannerList.refreshAfterGalleryClosed();
        bannerList.observeStickySkyscrapers();

        // request ads
        const bannerRequest = new BannerRequest(ctx);
        bannerRequest.perform();

        return {
            // APPNEXUS: showTag for horseshoe positions
            showHorseShoe(elements) {
                if (!isAdBlocker) {
                    elements.forEach(ele => {
                        const tagId = ele.getAttribute('data-astbanner-name');
                        ctx.apntag.anq.push(() => ctx.apntag.showTag(tagId));
                    });
                }
            },
            // APPNEXUS: showTag for board_* and netboard_* positions
            showBanner(tagId) {
                if (!isAdBlocker) {
                    ctx.apntag.anq.push(() => ctx.apntag.showTag(tagId));
                }
            },
        };
    },
};



// WEBPACK FOOTER //
// ./services/banner2/bannerast.js